import { createContext } from 'react';
import type {
  Data,
  Filters,
  GroupTagOption,
  Pagination,
  SetFilters,
  Sort,
  StarQuote,
  TranscriptSearchItem,
  UpdateTranscriptRangeTags,
} from './interfaces';

export const ProjectClipsDataContext = createContext<Data>(null);
export const ProjectClipsFiltersContext = createContext<Filters>(null);
export const SetProjectClipsFiltersContext = createContext<SetFilters>(null);
export const ProjectClipsSortContext = createContext<Sort>(null);
export const ProjectClipsPaginationContext = createContext<Pagination>(null);
export const ProjectClipsTranscriptSearchContext = createContext<TranscriptSearchItem[]>(null);
export const ProjectClipsStarQuoteContext = createContext<StarQuote>(null);
export const ProjectClipsUpdateTranscriptRangeTagsContext = createContext<UpdateTranscriptRangeTags>(null);

/**
 * Populated by each app's container with the available group tag options.
 * Shared UI components (AdditionalFilters.Menu) read from this context
 * so they never make API calls directly.
 */
export const ProjectClipsGroupTagsContext = createContext<GroupTagOption[]>([]);
